/**
 * Synthetic sidebar entries for contractor primary/member accounts
 * that do not receive UM menu rows for /SLN/Contractor/*.
 */
export const CONTRACTOR_ASSISTED_MENU_ITEM = {
  id: "contractor-assisted-registration",
  title: "ثبت متقاضی",
  link: "/SLN/Contractor/AssistedRegistration",
  icon: "PC",
  level: 3,
};

export const CONTRACTOR_TEAM_MENU_ITEM = {
  id: "contractor-team",
  title: "مدیریت تیم",
  link: "/SLN/Contractor/Team",
  icon: "UM",
  level: 3,
};

export const CONTRACTOR_SUPERVISION_MENU_ITEM = {
  id: "contractor-supervision",
  title: "نظارت",
  link: "/SLN/Contractor/supervision",
  icon: "SV",
  level: 3,
};

export const buildContractorModuleMenuItems = ({ canManageTeam = false } = {}) => {
  const items = [
    { ...CONTRACTOR_ASSISTED_MENU_ITEM },
    { ...CONTRACTOR_SUPERVISION_MENU_ITEM },
  ];
  if (canManageTeam) {
    items.push({ ...CONTRACTOR_TEAM_MENU_ITEM });
  }
  return items;
};

export const isContractorAreaPath = (pathname) => {
  const p = String(pathname || "")
    .toLowerCase()
    .replace(/\/+$/, "");
  return p === "/sln/contractor" || p.startsWith("/sln/contractor/");
};
